import React from "react";

import { createRouteRef } from "@backstage/core-plugin-api";
import {
    ApiBlueprint,
    createApiFactory,
    createFrontendPlugin,
    discoveryApiRef,
    fetchApiRef,
    PageBlueprint,
} from "@backstage/frontend-plugin-api";
import { pluginId } from "@internal/backstage-plugin-secret-sharing-common";

import { secretSharingApiRef, SecretSharingClient } from "./components/apis";

export const rootRouteRef = createRouteRef({
    id: pluginId,
});

export const SecretSharingPage = PageBlueprint.make({
    params: {
        path: "/secret-sharing",
        routeRef: rootRouteRef,
        title: "Secret Sharing",
        loader: async () => {
            const m = await import("./components/SecretSharingPage");
            return React.createElement(m.SecretSharingPage);
        },
    },
});

const secretSharingApiExt = ApiBlueprint.make({
    name: pluginId,
    params: defineParams =>
        defineParams(
            createApiFactory({
                api: secretSharingApiRef,
                deps: {
                    discoveryApi: discoveryApiRef,
                    fetchApi: fetchApiRef,
                },
                factory: ({ discoveryApi, fetchApi }) =>
                    new SecretSharingClient({ discoveryApi, fetchApi }),
            })
        ),
});

const secretSharingFrontendPlugin = createFrontendPlugin({
    pluginId,
    extensions: [SecretSharingPage, secretSharingApiExt],
});

export default secretSharingFrontendPlugin;
